import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  // private secretKey = `${Math.floor(Date.now() / 1000)}${environment.SECRET_KEY}`

  // Encrypt data
  encryptData(data: string, secretKey: string): string {
    try {
      return CryptoJS.AES.encrypt(data, secretKey).toString();
    } catch (e) {
      console.error('Error encrypting data', e);
      return '';
    }
  }

  // Decrypt data
  decryptData(encryptedData: string, secretKey: string): string {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error('Error decrypting data', e);
      return '';
    }
  }
}
